import { render, staticRenderFns } from "./data_link.vue?vue&type=template&id=0ba26590&scoped=true&"
import script from "./data_link.vue?vue&type=script&lang=js&"
export * from "./data_link.vue?vue&type=script&lang=js&"
import style0 from "./data_link.vue?vue&type=style&index=0&id=0ba26590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba26590",
  null
  
)

export default component.exports